<div class="search-bar-field-logbook-event">
  <span *ngIf="filter.key == 'event'">
    <span>Event is: </span>
    <span class="event-action" title="{{filter.item.title}}">
        {{filter.item.title}}
    </span>
  </span>
  <span
      title="Remove {{filter.key}} filter"
      class="event-action-btn"
      [ngClass]="style"
      (click)="onRemove(filter)"
  >X</span>
</div>